import { render, staticRenderFns } from "./InputDot.vue?vue&type=template&id=0d84070e&scoped=true&"
import script from "./InputDot.vue?vue&type=script&lang=js&"
export * from "./InputDot.vue?vue&type=script&lang=js&"
import style0 from "./InputDot.vue?vue&type=style&index=0&id=0d84070e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d84070e",
  null
  
)

export default component.exports